// Product Options Scroll - JavaScript solution
// Force variant options into horizontal scroll containers

(function() {
  'use strict';
  
  function makeOptionsScrollable() {
    // Find all variant option containers
    const selectors = [
      '.product-form__input fieldset',
      'fieldset[class*="variant"]',
      '.variant-picker fieldset',
      'fieldset.js'
    ];
    
    selectors.forEach(selector => {
      const fieldsets = document.querySelectorAll(selector);
      
      fieldsets.forEach(fieldset => {
        if (fieldset.classList.contains('scroll-applied')) return;
        
        // Apply styles
        fieldset.style.display = 'flex';
        fieldset.style.flexDirection = 'row';
        fieldset.style.flexWrap = 'nowrap';
        fieldset.style.gap = '10px';
        fieldset.style.padding = '12px';
        fieldset.style.overflowX = 'auto';
        fieldset.style.overflowY = 'hidden';
        fieldset.style.border = '2px solid #e5e7eb';
        fieldset.style.borderRadius = '8px';
        fieldset.style.background = '#f9fafb';
        fieldset.classList.add('scroll-applied');
        
        // Style radio button labels
        const labels = fieldset.querySelectorAll('input[type="radio"] + label');
        labels.forEach(label => {
          label.style.flexShrink = '0';
          label.style.minWidth = '100px';
          label.style.padding = '12px 16px';
          label.style.margin = '0';
          label.style.border = '2px solid #d1d5db';
          label.style.borderRadius = '6px';
          label.style.background = '#ffffff';
          label.style.cursor = 'pointer';
          label.style.transition = 'all 0.2s ease';
          label.style.textAlign = 'center';
          label.style.whiteSpace = 'nowrap';
          label.style.fontSize = '14px';
          
          // Check if this option is selected
          const radio = label.previousElementSibling;
          if (radio && radio.checked) {
            label.style.borderColor = '#2563eb';
            label.style.background = '#eff6ff';
            label.style.color = '#2563eb';
            label.style.fontWeight = '600';
          }
          
          // Add hover effect
          label.addEventListener('mouseenter', function() {
            if (!this.previousElementSibling.checked) {
              this.style.borderColor = '#2563eb';
              this.style.transform = 'translateY(-1px)';
            }
          });
          
          label.addEventListener('mouseleave', function() {
            if (!this.previousElementSibling.checked) {
              this.style.borderColor = '#d1d5db';
              this.style.transform = 'translateY(0)';
            }
          });
          
          // Update on click
          label.addEventListener('click', function() {
            // Reset all labels in this fieldset
            fieldset.querySelectorAll('input[type="radio"] + label').forEach(l => {
              l.style.borderColor = '#d1d5db';
              l.style.background = '#ffffff';
              l.style.color = 'inherit';
              l.style.fontWeight = 'normal';
            });
            
            // Highlight selected
            this.style.borderColor = '#2563eb';
            this.style.background = '#eff6ff';
            this.style.color = '#2563eb';
            this.style.fontWeight = '600';
          });
        });
        
        // Add scroll hint
        const parent = fieldset.parentElement;
        if (parent && !parent.querySelector('.scroll-hint')) {
          const hint = document.createElement('div');
          hint.className = 'scroll-hint';
          hint.textContent = '← Scroll to see more →';
          hint.style.textAlign = 'center';
          hint.style.fontSize = '11px';
          hint.style.color = '#6b7280';
          hint.style.fontStyle = 'italic';
          hint.style.marginTop = '6px';
          parent.appendChild(hint);
        }
      });
    });
  }
  
  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', makeOptionsScrollable);
  } else {
    makeOptionsScrollable();
  }
  
  // Run again after a delay (for dynamically loaded content)
  setTimeout(makeOptionsScrollable, 1000);
  setTimeout(makeOptionsScrollable, 2000);
  
  // Watch for DOM changes
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        makeOptionsScrollable();
      }
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
})();
